import { render, staticRenderFns } from "./AddLink.vue?vue&type=template&id=90a702d8&scoped=true"
import script from "./AddLink.vue?vue&type=script&lang=js"
export * from "./AddLink.vue?vue&type=script&lang=js"
import style0 from "./AddLink.vue?vue&type=style&index=0&id=90a702d8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90a702d8",
  null
  
)

export default component.exports